import { StarsButton } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch } from 'react-redux';

import CloseIcon from '@swf/core/assets/icons/close.svg';
import type { Dispatch } from '@swf/core/store';

export interface Props {
  onClick?(): void;
  className?: string;
  closeModal?: boolean;
}

const CloseButton: React.FC<Props> = ({ onClick, className, closeModal }) => {
  const { modal } = useDispatch<Dispatch>();
  return (
    <StarsButton
      variant="text"
      size="large"
      className={className}
      icon={<CloseIcon />}
      onClick={(evt) => {
        evt.stopPropagation();
        onClick && onClick();
        closeModal && modal.close();
      }}
    />
  );
};

export default CloseButton;
